/* GASSISA
=========================================================================================
* Descripción: Menú de acciones del módulo de parámetros de caja
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 22/03/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 22/03/2026 | Lic. José Luis Aragón Cervantes  | Cambiar Cancelar por Deshacer
* ---------------------------------------------------------------------------------------
*/

import { IconButton, Tooltip } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';
import HomeIcon from '@mui/icons-material/Home';

import { Fragment } from "react";
import { useDoubleClickPrevention } from '../../hooks/useDoubleClickPrevention';

export default function MnuParametrosCajaActions(props) {
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
    
    const { 
        handleClickRegresarMainDashboard,
        hasDraft, 
        isDirty, 
        onSave, 
        onDeshacer 
    } = props;

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>

            <Tooltip title={"Deshacer"}>
                <IconButton 
                    onClick={() => executeWithProtection(onDeshacer)}
                    disabled={isProcessing || !hasDraft}
                >
                    <UndoIcon className="icon" /><p className="icon">Deshacer</p>
                </IconButton>
            </Tooltip>

            <Tooltip title={"Aplicar"}>
                <IconButton 
                    onClick={() => executeWithProtection(onSave)}
                    disabled={isProcessing || !hasDraft || !isDirty}
                >
                    <SaveIcon className="icon" /><p className="icon">Aplicar</p>
                </IconButton>
            </Tooltip>
        </Fragment>
    );
}
